import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import MyWhatsAppPage from "@/pages/MyWhatsAppPage";
import ContactsPage from "@/pages/ContactsPage";
import FeedbacksPage from "@/pages/FeedbacksPage";
import SalesFunnelPage from "@/pages/SalesFunnelPage";
import SupervisorDashboardPage from "@/pages/SupervisorDashboardPage";
import { Loader2 } from "lucide-react";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return (
    <div className="min-h-screen bg-[#0B0F17] grid place-items-center">
      <Loader2 className="w-6 h-6 animate-spin text-emerald-400" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/" element={<Protected><DashboardPage /></Protected>} />
      <Route path="/whatsapp" element={<Protected><MyWhatsAppPage /></Protected>} />
      <Route path="/contacts" element={<Protected><ContactsPage /></Protected>} />
      <Route path="/leads" element={<Protected><FeedbacksPage /></Protected>} />
      <Route path="/funil" element={<Protected><SalesFunnelPage /></Protected>} />
      <Route path="/supervisor" element={<Protected roles={["supervisor", "admin"]}><SupervisorDashboardPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}


